import React from "react";
import Inspection from "../components/vehicleInspection/index.jsx";
import SeoMeta from "../components/meta";

export default function VehicleInspection() {
  return (
    <>
      <SeoMeta
        title="Get Your Car Inspected Today | Trusted Car Inspection by Famewheels"
        desc="Keep your car running smoothly and safely with car inspection of Fame Wheels. Our Experienced Staff will Completely examine the vehicle and identify all problem and you will fixed them."
        url="car-inspection"
      />
      <Inspection />
    </>
  );
}
